import { Injectable } from '@angular/core';
import { SavedMessages } from './messages.service';

export interface MessageSchedule {
  id: string,
  message: SavedMessages | undefined,
  messageDates: {date: string, time: string, timezone: string}[]
}

export interface CampaignSchedule {
  campaignStart: string | null,
  campaignEnd: string | null,
}
@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  campaignSchedule: CampaignSchedule = {
    campaignStart: '',
    campaignEnd: '',
  }

  messageSchedule: MessageSchedule[] = []

  constructor() { }

  reset() {
    this.campaignSchedule = {
      campaignStart: '',
      campaignEnd: '',
    }
    this.messageSchedule = []
  }

}
